/**
 * Button component
 */
import React from "react"
import PropTypes from "prop-types"
import { StyledButton } from "./styles"

let send = false

export const ThemeButton = props => {
  const launchEmail = () => {
    const emailTo = "info@vantageapp.io"
    const emailSubject = "Vantage: Report Issue"
    const emailBody =
      "Please provide a detailed explanation of the issue you are experiencing on Vantage.%0D%0A%0D%0A" +
      "Include the device, operating system and browser you are using.%0D%0A%0D%0A" +
      "Please also include a contact number so that we can call you to help resolve the issue.%0D%0A%0D%0A" +
      "Thank you"
    window.open(
      "mailto:" + emailTo + "?subject=" + emailSubject + "&body=" + emailBody
    )
  }

  const prepareToSend = () => {
    if (send) {
      launchEmail()
      document.getElementById("ReportIssue").blur()
    } else {
      send = true
    }
  }

  const cancelSend = () => {
    send = false
  }

  return (
    <StyledButton
      id={"ReportIssue"}
      attrs={props.attrs}
      filter={props.filter}
      small={props.small}
      back={props.back}
      onClick={prepareToSend}
      onBlur={cancelSend}
      disabled={props.disabled}
    />
  )
}

ThemeButton.defaultProps = {
  name: "primary",
}

ThemeButton.propTypes = {
  attrs: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  noMargin: PropTypes.bool,
  disabled: PropTypes.bool,
  back: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  small: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  filter: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  name: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
}

export default ThemeButton
